
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[...aId]",
      function () {
        return require("private-next-pages/[...aId].js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[...aId]"])
      });
    }
  